import React from "react";

const AboutMe = () => {
    return (
        <>

        </>
    );
}

export default AboutMe;